import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';

const locationHelper = locationHelperBuilder({});

export const userIsAuthenticatedRedir = connectedRouterRedirect({
  redirectPath: '/login',
  authenticatedSelector: state => state.account.user !== undefined,
  wrapperDisplayName: 'UserIsAuthenticated'
});

export const userIsNotAuthenticatedRedir = connectedRouterRedirect({
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/',
  allowRedirectBack: false,
  authenticatedSelector: state => state.account.user === undefined,
  wrapperDisplayName: 'UserIsNotAuthenticated'
});

export const userIsLockedRedir = connectedRouterRedirect({
  allowRedirectBack: false,
  redirectPath: '/wallet',
  authenticatedSelector: state => !state.account.user.isBanned,
  wrapperDisplayName: 'userIsLockedRedir'
});



// WEBPACK FOOTER //
// ./src/utils/helpers/auth.js